import Settings from "./settings";
import Autocomplete from "./autocomplete";
import EmailValidation from "./email-validation";
import AbrLookupByBusinessName from "./abr-lookup-by-business-name";
import GravityForms from "./gravity-forms";

document.addEventListener("DOMContentLoaded", () => {

	// missing forEach on NodeList for IE11
	if (window.NodeList && !NodeList.prototype.forEach) {
		window.NodeList.prototype.forEach = Array.prototype.forEach;
	}

	if (Settings.isAddressAutocompletionEnabled()) {

		//Automatically attach address autocompletion to WooCoommerce address fields
		let addressTypes = [
			"billing",
			"shipping",
		];

		addressTypes.forEach((addressType) => {
			let container = document.querySelector(".woocommerce-" + addressType + "-fields__field-wrapper,.woocommerce-address-fields__field-wrapper");
			let input = document.querySelector("#" + addressType + "_address_1");

			let autocomplete = new Autocomplete(container, input, {
				AddressLine1: "#" + addressType + "_address_1",
				AddressLine2: "#" + addressType + "_address_2",
				City: "#" + addressType + "_city",
				State: "#" + addressType + "_state",
				Postcode: "#" + addressType + "_postcode"
			});
			autocomplete.init();
		});
	}

	jQuery(document).on('gform_post_render', function() {

		if (Settings.isAddressAutocompletionEnabled()) {

			//Automatically attach address autocompletion to Gravity Forms address fields
			let addressContainers = document.querySelectorAll(".ginput_complex.ginput_container_address");

			addressContainers.forEach((container) => {
				let input = container.querySelector(".address_line_1 input");

				let autocomplete = new Autocomplete(container, input, {
					AddressLine1: ".address_line_1 input",
					AddressLine2: ".address_line_2 input",
					City: ".address_city input",
					State: [".address_state select", ".address_state input"],
					Postcode: ".address_zip input"
				});
				autocomplete.init();
			});
		}

		if (Settings.areAbrLookupsEnabled()) {
			let abrLookupByBusinessNameContainers = document.querySelectorAll(".js-abr-search-field--business-name");
			abrLookupByBusinessNameContainers.forEach((container) => {
				let input = container.querySelector('input');
				let inputNumber = GravityForms.getGfInputNumber(input);

				let abrAutocomplete = new AbrLookupByBusinessName(container, input, {
					BusinessName: ".js-abr-result-field--business-name.js-abr-result-link-field_" + inputNumber + " input",
					ABN: ".js-abr-result-field--abn.js-abr-result-link-field_" + inputNumber + " input",
					State: ".js-abr-result-field--state.js-abr-result-link-field_" + inputNumber + " input",
					Postcode: ".js-abr-result-field--postcode.js-abr-result-link-field_" + inputNumber + " input",
					Status: ".js-abr-result-field--status.js-abr-result-link-field_" + inputNumber + " input",
				});
				abrAutocomplete.init();
			});
		}

		if (Settings.isEmailValidationEnabled()) {
			EmailValidation.setupGfEmailValidation();
		}
	});
});
